import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/useAuth';
import { LoadingState } from '../../../shared/components/ui/LoadingState';

interface PublicOnlyRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({
  children,
  redirectTo = '/dashboard',
}) => {
  const { user, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated && user) {
      // User is logged in, redirect them away from auth pages
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, user, loading, navigate, redirectTo]);

  // Show loading while checking auth status
  if (loading) {
    return <LoadingState type="auth" />;
  }

  // If user is authenticated, don't render the children (they'll be redirected)
  if (isAuthenticated && user) {
    return null;
  }

  // User is not authenticated, show the auth page
  return <>{children}</>;
};
